export const isCompletedApplePayPayment = (
  paymentSource?: string | null,
  paymentStatus?: string | null
) => paymentSource === "NONCE" && paymentStatus === "COMPLETED";
